<template>
  <div ref="test_screen_shot" id="id_screen_shot">
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:20px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Divider />
    <Row type="flex" justify="space-around">
      <Col span="4">
        <Card @click.native="change_balance_type" style="cursor:pointer;">
          <h4 slot="title" style="text-align:center;white-space:nowrap;">
            <Tooltip placement="top" content="单击切换 usd/xbt" delay:1000>账户总余额</Tooltip>
          </h4>
          <p
            v-if="balance_type == 'usd'"
            style="font-size:28px;text-align:center;white-space:nowrap"
          >
            {{ balance_usd_show }}
            <Icon type="logo-usd" style="margin-top:-10px;" />
          </p>
          <p v-else style="font-size:30px;text-align:center;white-space:nowrap">
            {{ balance_xbt }}
            <Icon type="logo-bitcoin" style="margin-top:-10px;" />
          </p>
        </Card>
      </Col>
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">账户盈利率</h4>
          <p
            style="font-size:28px;text-align:center;white-space:nowrap;"
          >{{ account_current_profit }} %</p>
        </Card>
      </Col>
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">已运行天数</h4>
          <p style="font-size:28px;text-align:center;white-space:nowrap;">{{ total_trade_days }}</p>
        </Card>
      </Col>
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">总交易次数</h4>
          <p style="font-size:28px;text-align:center;white-space:nowrap;">{{ total_trade_number }}</p>
        </Card>
      </Col>
      <Col span="5">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">邮箱</h4>
          <p id="email_p" style="font-size:28px;text-align:center;white-space:nowrap;">{{ account_email }}</p>
        </Card>
      </Col>
    </Row>
    <Row style="height:30px;"></Row>
    <div ref="echarts_curve_ref" style="width:100%;height:500px;margin:0 auto;"></div>
    <Row style="height:30px;">
      <Col span="4">
        <Input
          id="report_input"
          :type="input_show"
          style="width: auto"
          v-model="account_id"
          @keyup.enter.native="new_account_id_set()"
        />
        </Input>
      </Col>
    </Row>
    <div ref="echarts_drawdown_ref" style="width:100%;height:500px;margin:0 auto;"></div>
  </div>
</template>


<script>
import {
  draw_line_chart,
  draw_pie_chart,
  draw_bar_chart,
  array_to_object,
  num_format,
} from "../utils";
import qs from 'qs'
import html2canvas from "html2canvas";
export default {
  name: "run_report",
  components: {
    html2canvas
  },
  data() {
    return {
      table_title: "账户运行报告",
      input_show: "text",
      account_id: "",
      balance_usd: 0,
      balance_xbt: 0,
      total_trade_days: 0,
      total_trade_number: 0,
      account_current_profit: 0,
      balance_usd_show: null,
      balance_type: "usd"
    };
  },
  watch: {
    balance_usd(old_value) {
      this.balance_usd_show = num_format(this.balance_usd);
    }
  },
  methods: {
    new_account_id_set: function() {
      this.load_static_data();
      setTimeout(() => {
        this.load_echarts_data();
        this.input_show = "hidden";
      }, 1500);
      setTimeout(() => {
        this.to_image()
      }, 10000)
    },
    send_url: async function(image_data) {
      let data = await this.$axios.post(
        this.$store.state.urlPort + "/strategy_report",
         qs.stringify({"account_id": this.account_id, "mode":"report_with_img", "data":image_data})
      );
      if (data["status"] == true) {
        this.$Message.success({ content: data["data"], duration: 5 });
      } else {
        this.$Message.error({ content: data["data"], duration: 5 });
      }
    },
    to_image: async function() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      const canvas = await html2canvas(this.$refs.test_screen_shot, {
        useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
        allowTaint: false
      })
      let image_data = canvas.toDataURL("png");
      this.input_show = "text"
      this.account_id = image_data
      //this.send_url(image_data);
    },
    draw_curve_and_drawdown_line: function() {
      if (this.balance_type == "xbt") {
        draw_line_chart(
          this.$refs.echarts_curve_ref,
          this.curve_xbt["name"],
          this.curve_xbt["x_data"],
          this.curve_xbt["y_data"]
        );
        draw_line_chart(
          this.$refs.echarts_drawdown_ref,
          this.drawdown_xbt["name"],
          this.drawdown_xbt["x_data"],
          this.drawdown_xbt["y_data"]
        );
      } else {
        draw_line_chart(
          this.$refs.echarts_curve_ref,
          this.curve_usd["name"],
          this.curve_usd["x_data"],
          this.curve_usd["y_data"]
        );
        draw_line_chart(
          this.$refs.echarts_drawdown_ref,
          this.drawdown_usd["name"],
          this.drawdown_usd["x_data"],
          this.drawdown_usd["y_data"]
        );
      }
      this.flush_account_current_profit();
    },
    change_balance_type: function() {
      if (this.balance_type == "usd") {
        this.balance_type = "xbt";
        this.draw_curve_and_drawdown_line();
      } else {
        this.balance_type = "usd";
        this.draw_curve_and_drawdown_line();
      }
    },
    flush_account_current_profit() {
      if (this.curve_xbt.hasOwnProperty("y_data") == false) {
        return null;
      }
      if (this.balance_type == "xbt") {
        var final_share = this.curve_xbt["final_share"];
        var end = this.balance_xbt;
      } else {
        var final_share = this.curve_usd["final_share"];
        var end = this.balance_usd;
      }
      this.account_current_profit = (100 * (end / final_share - 1)).toFixed(2);
    },
    load_echarts_data: async function() {
      this.curve_usd = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "curve_usd", which_web_need: this.account_id } }
      );
      this.drawdown_usd = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "drawdown_usd", which_web_need: this.account_id } }
      );
      this.curve_xbt = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "curve_xbt", which_web_need: this.account_id } }
      );
      this.drawdown_xbt = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "drawdown_xbt", which_web_need: this.account_id } }
      );

      this.draw_curve_and_drawdown_line();
    },
    load_static_data: async function() {
      let data = await this.$axios.get(
        this.$store.state.urlPort + "/load_account_overview_static_data",
        { params: { which_web_need: this.account_id } }
      );
      this.balance_usd = data["balance_usd"];
      this.balance_xbt = data["balance_xbt"];
      this.total_trade_number = data["total_trade_number"];
      this.total_trade_days = data["total_trade_days"];
      this.account_email = data["account_email"];

      // 确定净值曲线选择显示哪一条
      const formData = new FormData();
      formData.append("data", null);
      formData.append("account_id", this.account_id);
      formData.append("mode", "get_account_msg");
      let report_data = await this.$axios({
        url: this.$store.state.urlPort + "/strategy_report",
        method: "post",
        data: formData
      });
      // 0 币本 1 金本
      var show_which_line = Number(report_data["data"][0][2])
      if (show_which_line == 0) {
        this.balance_type = "xbt"
      }
      else {
        this.balance_type = "usd"
      }

      // 0 资金量 1.净值 2.百分比
      var show_which_line = Number(report_data["data"][0][3])
      var item_name = this.balance_type == "usd"?"legend_usd_selected_name":"legend_xbt_selected_name"
      if (show_which_line == 0) {
        localStorage.setItem(item_name, this.balance_type.toUpperCase() + "资金量")
      }
      else if(show_which_line == 1) {
        localStorage.setItem(item_name, this.balance_type.toUpperCase() + "资金净值")
      }
      else {
        localStorage.setItem(item_name, this.balance_type.toUpperCase() + "资金百分比")
      }

      setTimeout(() => {
        this.flush_account_current_profit();
      }, 1000);
    }
  },
  mounted() {},
  created: function() {},
  destroyed() {}
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>